import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule, NgModel } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Router } from '@angular/router';
import { CaisServiceService } from 'app/Pages/cais/cais-service.service';
import { APIURL } from 'app/Shared/Constant/API_Urls';
import { GridService } from 'app/Shared/Services/grid.service';
import { SharedHttpClientService } from 'app/Shared/Services/shared-http-client.service';
import { UrlsService } from 'app/Shared/Services/urls.service';
import { UserService } from 'app/Shared/Services/user.service';
import { mode } from 'crypto-js';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { DrawerModule } from 'primeng/drawer';
import { map } from 'rxjs';

@Component({
    selector: 'app-view-fdid',
    templateUrl: './view-fdid.component.html',
    styleUrl: './view-fdid.component.scss',
    imports: [DrawerModule, ButtonModule, CheckboxModule, FormsModule, MatProgressSpinnerModule,CommonModule]
})
export class ViewFdidComponent {
  @Input('selectedFDIDDetails') selectedFDIDDetails: any;
  @Input('displaySideBar') displaySideBar: boolean = false;
  @Input('viewFDIDOpen') viewFDIDOpen: boolean = false;
  @Output() closeDialog: EventEmitter<any> = new EventEmitter();
  checked: boolean = false;
  isLoadingResults: boolean = false;
  Add: boolean = false;
  selectedFDID: any ={catReporterIMID:"",accountNumber:"",name:"",givenName:"",receivedFDID:"",generatedFDID:"",active:""}

  constructor(
    private sharedHttpClientService: SharedHttpClientService,
    private userService: UserService,
    private urlsService: UrlsService,
    private router: Router,
    public caisService: CaisServiceService
  ) { }


  ngOnInit(): void {
    this.onClickGetFDIDDetails();
  }

  onClickGetFDIDDetails() {
    this.selectedFDID = [];
    let payload = [];
    if(this.selectedFDIDDetails['actualValue'].length == 40){
    payload.push({
      "isdefault": "true", "label": "Generated FDID", "columnname": "tf.generatedFDID", "filterby": "IS", "values": this.selectedFDIDDetails.actualValue,
      "time": "", "datatype": "String", "disabled": "true", "dropdown": "", "dropdownvalue": "", "placeholder": "Generated FDID", "className": "", "isLarge": true
    })}
    else{
      payload.push({
        'isdefault': 'true', 'label': 'Given Name', 'columnname': 'tf.givenName', 'filterby': 'IS', 'values': this.selectedFDIDDetails.actualValue,
        'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': ''
      })
    }
    this.isLoadingResults = true;
    let Data = {
      "data": payload,
      "mpid": this.userService.getActiveMPID(),
      "startLimit": '0',
      'endLimit': '1',
      'pageName': 'FDID-Info',
    };
    return this.sharedHttpClientService.post(this.urlsService.setAPIURl(APIURL.CAT_FDID), Data)
      .pipe(map((response: Response) => {
        return response;
      })).subscribe({
        next: (response: any) => {
          this.isLoadingResults = false;
          let jsondataset: any;
          jsondataset = response;
          if(jsondataset != undefined && jsondataset.Data[0] != undefined){
          this.selectedFDID = jsondataset.Data[0];
          }

        },
        error: (err: HttpErrorResponse) => {
          this.isLoadingResults = false;
        }
      });
  }
  onClickCancelFDID(boolean:any) {
    this.closeDialog.emit(boolean);
    this.viewFDIDOpen = false;
  }
  AddCaisFDID() {
    let urlParams = {
      "accountName": this.selectedFDID.name,
      "accountNumber": this.selectedFDID.accountNumber,
      "receivedFDID": this.selectedFDID.receivedFDID,
      "firmDesignatedID": this.selectedFDID.generatedFDID
    };
    this.router.navigate([]).then(result => { window.open('#/Rsms/pages/CAIS/FDID?mode=Add&FDIDData=' + btoa(JSON.stringify(urlParams))) });
  }


}
